import { Container, Text } from "basis";
import { CloseAccountImportantInformationList } from "./CloseAccountImportantInformationList";

function CloseAccountImportantInformation({ canHaveRewardPoints }) {
  return (
    <Container bg="secondary.lightBlue.t25" padding="4">
      <Container bg="white" padding="6">
        <Text textStyle="heading5" margin="0 0 4 0">
          Important information
        </Text>
        <CloseAccountImportantInformationList
          canHaveRewardPoints={canHaveRewardPoints}
        />
      </Container>
    </Container>
  );
}

export { CloseAccountImportantInformation };
